import { useState, useEffect, useRef } from 'react';
import Footer from '../../../components/footer/Footer';
import Navbar from '../../../components/navbar/navbar';
import DynamicInfo from '../dynamic-info/dynamic-info';
import StaticInfo from '../static-info/static-info';
import './home-main.css';
import axios from 'axios';

function HomeMain() {
  sessionStorage.setItem("routeEs", `/`);
  sessionStorage.setItem("routeEn", `/`);
  const [arrAdvertisements, setArrAdvertisements] = useState([]);
  const navContentRef = useRef(null);

  useEffect(() => {
    const navEl = navContentRef.current;
    if (!navEl) return;

    const syncHeaderOffset = () => {
      document.documentElement.style.setProperty(
        '--home-header-offset',
        `${navEl.offsetHeight}px`
      );
    };

    syncHeaderOffset();
    const observer = new ResizeObserver(syncHeaderOffset);
    observer.observe(navEl);
    return () => observer.disconnect();
  }, [arrAdvertisements.length]);

  const getInfo = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_BACKEND}/api/advertisement`
      const response = await axios.get(url, {headers: {
        Authorization: process.env.REACT_APP_PUBLIC_KEY
      }});
      const advertisements = response.data.data.filter(item => item.type === "advertisement");
      setArrAdvertisements(advertisements);
    } catch (error) {
      console.log(error);
    }
  }

  return(
    <>
      <div className='home-content-main'>
        
        <div className='nav-content' ref={navContentRef}>
          <Navbar />
        </div>


        <div className='info-content'>

          <div className='body-info-content'>
            <div className='desktop-home'>
              <StaticInfo />
            </div>
            <DynamicInfo />
          </div>

          <div className='content-footer-home'>
            <Footer />
          </div>

        </div>

      </div>
    </>
  )
}

export default HomeMain;